import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/interview-questions')({
  component: InterviewQuestionsPage,
});

function InterviewQuestionsPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Interview Questions</h1>
      <p className="text-muted-foreground">
        Manage interview question bank. This page is under development.
      </p>
    </div>
  );
}
